__turbopack_context__.v({
  "actionButton": "ValidateBrc20-module___19Qqq__actionButton",
  "brc20ButtonContainer": "ValidateBrc20-module___19Qqq__brc20ButtonContainer",
  "brc20Detail": "ValidateBrc20-module___19Qqq__brc20Detail",
  "brc20Details": "ValidateBrc20-module___19Qqq__brc20Details",
  "brc20Text": "ValidateBrc20-module___19Qqq__brc20Text",
  "buttonLoader": "ValidateBrc20-module___19Qqq__buttonLoader",
  "icon": "ValidateBrc20-module___19Qqq__icon",
  "root": "ValidateBrc20-module___19Qqq__root",
});
